<template>
    <div class="col-md-8 mx-auto p-4">
        <p class="pt-3" v-if="this.breadcrumb.length === 0">دسته آگهی مورد نظر خود را انتخاب کنید.</p>

        <a class="btn btn-link text-decoration-none text-dark mb-2"
           v-if="this.breadcrumb.length >= 1 && showCategory"
           @click="backCategory()">
            بازگشت به دسته اصلی

            <i class="fa fa-arrow-left text-dark mx-2"></i>
        </a>

        <nav aria-label="breadcrumb" class="breads mx-5 mt-5" v-if="breadcrumb.length > 0" @click="loadCategory()">
            <ol class="breadcrumb">
                <li class="breadcrumb-item mx-2" aria-current="page" v-for="item in breadcrumb">{{ item }}</li>
            </ol>
        </nav>

        <ul v-show="showCategory" style="list-style: none" class="my-5">
            <li style="font-size: 11pt;"
                class="cursor-pointer py-2 px-5"
                v-for="item in categories.filter((x) => x.parentSlug === current)"
                @click="changeCategory(item)">
                <i v-for="x in catIcons.filter(y => y.slug === item.slug)" :class="x.icon"
                   style="margin: 0 1rem;font-size: 14pt;color: #3F51B5"></i>

                <i :class="'kt-icon kt-icon-' + item.slug + ' kt-icon--lg kt-base-row__icon'"
                   v-if="item.parentSlug === 'root'"></i>

                {{ item.title }}

                <i class="fa fa-chevron-left float-left my-2" style="color: #3F51B5"></i>
            </li>
            <li @click="changeCategory(categories.find((x) => x.slug === current))"
                style="font-size: 11pt;" class="cursor-pointer py-2 px-5"
                v-if="breadcrumb.length >=1">
                متفرقه

                <i class="fa fa-chevron-left float-left my-2" style="color: #3F51B5"></i>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "Categories",
    props: {
        value: {
            required: false,
        }
    },
    data() {
        return {
            categories: [],
            before: [],
            breadcrumb: [],
            showCategory: true,
            current: 'real-estate',
            catIcons: [
                {icon: "fa fa-home", slug: "real-estate"},
                {icon: "fa fa-car", slug: "vehicles"},
                {icon: "fa fa-desktop", slug: "electronic-devices"},
                {icon: "fa fa-lightbulb", slug: "home-kitchen"},
                {icon: "fa fa-wrench", slug: "services"},
                {icon: "fa fa-user", slug: "personal"},
                {icon: "fa fa-dice", slug: "leisure-hobbies"},
                {icon: "fa fa-users", slug: "community"},
                {icon: "fa fa-industry", slug: "tools-materials-equipment"},
                {icon: "fa fa-briefcase", slug: "jobs"},
            ],
        }
    },
    methods: {
        getCategories() {
            $.ajax({
                url: `${url}/user/divar/categories`,
                type: "GET",
                fn: this.getCategories,
                dataType: "json",
                headers: {
                    ACCEPT: "application/json",
                    Authorization: Token
                },
                success: (data) => {
                    this.categories = data.data;

                    if (this.value)
                        this.changeCategoryByChild(this.value);
                }
            });
        },
        loadCategory() {
            this.$data.showCategory = true;
            this.$data.current = this.$data.before.pop();
            this.$data.breadcrumb.pop();
        },
        backCategory() {
            if (this.before.length <= 0)
                return;

            this.current = this.before.pop();
            this.breadcrumb.pop();
        },
        changeCategory(item) {
            let search = this.categories.filter(x => x.parentSlug === item.slug);

            if (search.length === 0 || this.current === item.slug) {
                this.showCategory = false;
                this.$emit("input", item);
            }

            this.before.push(this.current);
            this.current = item.slug;
            this.breadcrumb.push(item.title);
        },
        changeCategoryByChild(item) {
            let steps = [];
            console.log(item.slug)
            item = this.categories.find(x => x.slug === item.slug);
            console.log(item)
            while (item.slug !== "root") {
                steps.push(item);
                item = this.categories.find(x => x.slug === item.parentSlug);
                console.log(item)
            }

            steps.reverse().forEach((item) => {
                console.log(item)
                this.changeCategory(item);
            });
        }
    },
    watch: {
        current(val) {
            if (val === 'real-estate' && this.breadcrumb.length === 0 && this.before.length === 0) {
                this.getCategories();
                this.showCategory=true;
            }
        }
    },
    mounted() {
        this.getCategories();
    }
}
</script>

<style scoped>

</style>